module.exports = __webpack_public_path__ + "img/UCJC.965ba44a.jpg";